<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>
<div *ngIf="!loading">

    <h1 style="margin-top:0;margin-bottom:1em">
        Responses - {{username}}
    </h1>

    <mat-card style="margin-bottom: 4em;">

        <table mat-table [dataSource]="modulesOrdered" matSort multiTemplateDataRows (matSortChange)="sortModules($event)">

            <ng-container matColumnDef="Label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Module</th>
                <td mat-cell *matCellDef="let module">
                    <strong>
                        {{module.label}}
                    </strong>
                </td>
            </ng-container>

            <ng-container matColumnDef="Mark">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mark</th>
                <td mat-cell *matCellDef="let module">

                    <span *ngIf="module.type == ModuleType.TEST && module.questions.size != 0">
                        {{ module.getMark(this.userId) }} / {{ module.questions.size}}
                    </span>

                    <div *ngIf="module.type == ModuleType.TEST && module.questions.size == 0" fxLayoutAlign="start center" fxLayoutGap="0.5em">
                        <span>None</span>
                        <mat-icon matTooltip="No Questions">help_outline</mat-icon>
                    </div>

                    <div *ngIf="module.type == ModuleType.SURVEY" fxLayoutAlign="start center" fxLayoutGap="0.5em">
                        <span>None</span>
                        <mat-icon matTooltip="Survey">help_outline</mat-icon>
                    </div>

                </td>
            </ng-container>

            <ng-container matColumnDef="MarkPercentage">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let module" style="text-align: right;">
                    <span *ngIf="module.type == ModuleType.TEST && module.questions.size != 0">
                        {{module.getMark(this.userId) / module.questions.size | percent : '1.2-2'}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="ExpandedIndicator">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let module" style="text-align: right;">
                    <mat-icon>expand_{{module.expanded ? 'less' : 'more'}}</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedModule">
                <td mat-cell *matCellDef="let module" [attr.colspan]="columnsToDisplay.length">

                    <div class="module-detail" [@detailExpand]="module.expanded ? 'expanded' : 'collapsed'" fxLayout="column" style="padding-left: 2em;">

                        <div *ngFor="let questionId of module.questionsOrderedIDs; let i = index;" style="margin-bottom: 1em; ">
                            <ng-container *ngTemplateOutlet="question; context: { module: module, question: module.questions.get(questionId), index: i} ">
                            </ng-container>
                        </div>

                        <div *ngIf="module.questions.size == 0" style="margin-bottom: 1em;">
                            <p>No Questions</p>
                        </div>

                    </div>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let module; columns: columnsToDisplay;" class="module-row" [class.module-expanded-row]="module.expanded" (click)="module.expanded = !module.expanded"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedModule'];" class="expanded-row"></tr>

        </table>

    </mat-card>

</div>

<ng-template #question let-module="module" let-question="question" let-index="index">

    <p fxLayoutAlign="start center" fxLayoutGap="0.25rem">
        <strong>Question {{index + 1}} - {{question.value}}</strong>
        <mat-icon *ngIf="module.type == ModuleType.TEST && question.userResponses.has(this.userId) && question.userResponses.get(this.userId).response.correct" color="accent" matTooltip="Correct">check_circle</mat-icon>
        <mat-icon *ngIf="module.type == ModuleType.TEST && (!question.userResponses.has(this.userId) || !question.userResponses.get(this.userId).response.correct)" color="warn" matTooltip="Incorrect">cancel</mat-icon>
    </p>

    <ng-container *ngIf="question.userResponses.has(this.userId)">
        <ng-container *ngTemplateOutlet="response; context: { module: module, question: question, userResponse: question.userResponses.get(this.userId) }">
        </ng-container>
    </ng-container>

    <div *ngIf="!question.userResponses.has(this.userId)">
        <p>No Response</p>
    </div>

</ng-template>


<ng-template #response let-module="module" let-question="question" let-userResponse="userResponse">

    <ng-container *ngIf="question.type == QuestionType.MULTIPLE_CHOICE || question.type == QuestionType.MULTIPLE_SELECT">
        <p *ngFor="let choice of userResponse.response.choices">
            {{choice.value}}
        </p>
    </ng-container>

    <ng-container *ngIf="question.type == QuestionType.SHORT_FORM || question.type == QuestionType.LONG_FORM">
        <p *ngIf="userResponse.response.value">{{userResponse.response.value}}</p>
    </ng-container>

    <ng-container *ngIf="question.type == QuestionType.LIKERT">
        <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="1rem" style="padding:1rem 2rem">
            <mat-radio-group [value]="userResponse.response.value[choiceIndex]" *ngFor="let choice of question.choicesOrdered; let choiceIndex = index" fxLayoutAlign="space-between end">
                <div *ngIf="choice.value[0]" fxFlex="15"><strong>{{choice.value[0]}}</strong></div>
                <div *ngIf="choice.value[1] || question.defaultMinLabel" fxFlex="10">{{choice.value[1] || question.defaultMinLabel}}</div>
                <mat-radio-button class="likert" *ngFor="let option of question.scaleOptionArray" [value]="option" color="primary" disabled fxFlex>{{option + 1}}</mat-radio-button>
                <div *ngIf="choice.value[2] || question.defaultMaxLabel" fxFlex="10">{{choice.value[2] || question.defaultMaxLabel}}</div>
            </mat-radio-group>
        </div>
    </ng-container>

</ng-template>